import { z } from 'zod';
import { BaseRubricSchema } from 'libs/end-to-end/src/types/ai-interviewer/base-rubric';

// Resumes will be graded according to a list of quality score rubrics.
// Each score rubric item will have a description and a weight.
// The score key will be used to identify the score rubric in the resume grading cache.
// The lastModified field will be used to know when to update the cache.
export const ResumeQualityScoreRubric = BaseRubricSchema.extend({
  score_key: z.string(),
}).describe('ResumeQualityScoreRubric');

export type ResumeQualityScoreRubric = z.infer<typeof ResumeQualityScoreRubric>;

export const ResumeQualityScoreAssessmentItem = z
  .object({
    score_key: z.string(),
    score_item_text: z.string(),
    score_item_weight: z.number(),
    score_item_grade: z.number(),
    score_updated_at: z.number().int(), //Epoch timestamp
    score_item_explanation: z.string(),
  })
  .describe('ResumeQualityScoreAssessmentItem');

export type ResumeQualityScoreAssessmentItem = z.infer<
  typeof ResumeQualityScoreAssessmentItem
>;

export const ResumeQualityScoreAssessment = z
  .array(ResumeQualityScoreAssessmentItem)
  .describe('ResumeQualityScoreAssessment');

export type ResumeQualityScoreAssessment = z.infer<
  typeof ResumeQualityScoreAssessment
>;

export const OpenAIRubricItemAssessment = z
  .object({
    score: z.number(),
    explanation: z.string(),
  })
  .describe('OpenAIRubricItemAssessment');

export type OpenAIRubricItemAssessment = z.infer<
  typeof OpenAIRubricItemAssessment
>;
